import { Grid, Typography } from "@mui/material";
import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { ExternalLink } from "ExternalLink";
import { OLButton } from "OLButton";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";
import { JsonEditor as Editor } from "json-edit-react";
import { useState } from "react";
import { Draft, SchemaAttribute } from "types/customEvents";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    codeWrapper: {
      overflow: "scroll",
      maxHeight: 500,

      "& .jer-confirm-buttons svg": {
        width: "20px",
      },
    },
    wrapper: {
      overflow: "hidden",
    },
    title: {
      fontSize: 20,
      fontWeight: 500,
      color: theme.black,
      marginBottom: theme.spacing(6),
    },
    desc: {
      marginBottom: theme.spacing(18),
      color: theme.gray500,
      fontSize: 12,
      fontWeight: 400,
    },
  }),
);

interface Props {
  closeModal: () => void;
  onSave?: () => void;
  json?: SchemaAttribute | Draft;
  setFieldValue: (value: any) => void;
}

export const JsonEditor = ({
  closeModal,
  json,
  setFieldValue,
  onSave,
}: Props) => {
  const [code, setCode] = useState<SchemaAttribute | {}>(json || {});
  const classes = useStyles();
  const { message } = useMessage();

  return (
    <div className={classes.wrapper}>
      <Typography className={classes.title}>
        {message({ id: "previewCode" })}
      </Typography>
      <Typography className={classes.desc}>
        {message(
          { id: "schemaCodeLearnMore" },
          {
            link: (
              <ExternalLink path="https://help.openloyalty.io/main-features/members/custom-events/custom-event-schemas">
                {message({ id: "customEventSchemas" })}
              </ExternalLink>
            ),
            apiDocs: (
              <ExternalLink path="https://apidocs.openloyalty.io/#operation/customEventSchemaPost">
                {message({ id: "apiDocumentation" })}
              </ExternalLink>
            ),
          },
        )}
      </Typography>
      <div className={classes.codeWrapper}>
        <Editor
          maxWidth="100%"
          showCollectionCount={false}
          rootFontSize={12}
          indent={2}
          rootName="attribute"
          data={code}
          onUpdate={async ({ newData }) => {
            setCode(newData);
          }}
        />
      </div>
      <Grid container mt={8}>
        <Grid item mr={8}>
          <OLButton onClick={closeModal} variant="outlined">
            {message({ id: "cancel" })}
          </OLButton>
        </Grid>
        <Grid item>
          <OLButton
            onClick={() => {
              setFieldValue(code);
              onSave && onSave();
            }}
            variant="contained"
          >
            {message({ id: "saveCode" })}
          </OLButton>
        </Grid>
      </Grid>
    </div>
  );
};
